export default {
order_issues: "Order Issues",
loading_issues: "Loading issues...",

report_id: "Report ID",
order_id: "Order ID",
restaurant: "Restaurant",
issue: "Issue",
description: "Description",
status: "Status",
action: "Action",

resolve: "Resolve",
view: "View",

no_issues: "No issues found",

issue_resolved: "Resolved",
issue_pending: "Pending",
issue_open: "Open",
issue_details: "Issue Details",
action_taken: "Action Taken",
resolved_on: "Resolved On",
under_review: "Under Review",

resolve_issue: "Resolve Issue",
damaged_products: "Damaged Products",

select_action: "Select Action",
refund_issued: "Refund Issued",
replacement_sent: "Replacement Sent",
issue_fixed: "Issue Fixed",

refund_amount: "Refund Amount",
mark_resolved: "Mark as Resolved",
close: "Close",
refund: "Refund",
notes: "Notes",
currency_code: "QAR",

refund_issued: "Refund Issued",
replacement_sent: "Replacement Sent",
issue_fixed: "Issue Fixed",
under_review: "Under Review",
resolved: "Resolved",
last_7_days: "Last 7 Days",
last_15_days: "Last 15 Days",
last_30_days: "Last 30 Days",
last_1_month: "Last 1 Month",
last_3_months: "Last 3 Months",
last_6_months: "Last 6 Months",
last_1_year: "Last 1 Year",
issue_search:"Search for Restaurants",
issue_status:"Issue Status",
issue_type:"Issue Type",
calendar:"Calendar wise"
}